export default function identity(value) {
    return value;
}
//# sourceMappingURL=identity.js.map